export default __webpack_public_path__ + "static/physiolymp-kontakt_2023-1f308b40e2207c4adabd70b19da6ebc7.png";